<script setup>
  import { useRoute } from "vue-router";
  import { onMounted, ref } from "vue";
  import { useFetch } from "@/composables/useFetch.js";
  import { uri } from "@/constants/config.js";
  import { useI18n } from "vue-i18n";
  import ChatComponent from "./TicketComponent.vue";
  import TicketComponent from "./TicketComponent.vue";

  const { role } = defineProps({
    role: {
      type: String,
      default: "admin",
    },
  });

  const route = useRoute();
  const id = ref(route.params.id);
  const loadingFlag = ref(true);
  const ticketInformation = ref({});
  const { t: $t } = useI18n();

  const getTicket = async () => {
    loadingFlag.value = true;
    let ticket = null;

    const urls = {
      admin: `${uri.admin.support.ticket.view}/${id.value}`,
      cloud: `${uri.admin.cloud.support.ticket.view}/${id.value}`,
    };
    const url = urls[role];

    try {
      const { data, error } = await useFetch(url, { method: "GET" });
      if (data) {
        ticket = data;
      }
    } catch (err) {
      console.error(err);
    }
    return ticket;
  };

  const fetchData = async () => {
    try {
      const [ticketData] = await Promise.all([getTicket()]);
      ticketInformation.value = ticketData;
    } catch (error) {
    } finally {
      loadingFlag.value = false;
    }
  };

  // Fetch data when the component mounts
  onMounted(fetchData);

  async function sendTicket(message) {
    loadingFlag.value = true;
    const urls = {
      admin: `${uri.admin.support.ticket.reply}/${id.value}`,
      cloud: `${uri.admin.cloud.support.ticket.reply}/${id.value}`,
    };
    const url = urls[role];

    const requestParams = {
      description: message.text,
    };
    loadingFlag.value = true;
    try {
      const { data, error } = await useFetch(url, {
        method: "POST",
        body: requestParams,
      });
      if (data) {
        await fetchData();
      }
    } catch (err) {}
    loadingFlag.value = false;
  }

  async function closeTicket() {
    loadingFlag.value = true;
    const urls = {
      admin: `${uri.admin.support.ticket.close}/${id.value}`,
      cloud: `${uri.admin.cloud.support.ticket.close}/${id.value}`,
    };
    const url = urls[role];

    try {
      const { data, error } = await useFetch(url, { method: "DELETE" });
      if (data) {
        await fetchData();
      }
    } catch (err) {}
    loadingFlag.value = false;
  }
</script>

<template>
  <!-- BEGIN: Ticket -->
  <div class="gap-3 mt-3 intro-y">
    <TicketComponent
      :is-loading="loadingFlag"
      :data="ticketInformation"
      @send="sendTicket"
      @close="closeTicket"
    />
  </div>
</template>

<style scoped></style>
